<template>
    <div :class="`email-align-${localMailAlign} email`">
        <label for="email" class="field-label" @click="focusFieldLabel" v-if="!editingFieldLabel">
            {{ displayFieldEmail }}
            <span v-if="isRequired" class="required-indicator">*</span>
        </label>
            <input
            v-if="editingFieldLabel"
                type="text"
            class="field-label-input"
            placeholder="E-posta"
                v-model="localFieldEmail"
            @blur="stopEditingFieldLabel"
            @keydown.enter="stopEditingFieldLabel"
            ref="fieldLabelInput"
            />
        <div :class="['input-wrapper', { 'filled': emailValue }]">
                <input
                    type="email"
                    id="email"
                name="email"
                v-model="emailValue"
                @input="updateField"
                @focus="onFocus"
                @blur="onBlur"
                :class="{ 'has-value': emailValue }"
            />
            <label for="email" class="floating-label">{{ altLabel || 'example@example.com' }}</label>
            <div class="input-border"></div>
        </div>
    </div>
</template>

<script>
import { mapActions } from "vuex";

export default {
    name: "FormEmail",
    props: {
        fieldEmail: String,
        mailAlign: String,
        altLabel: String,
        isRequired: Boolean,
        item: Object,
    },
    data() {
        return {
            localFieldEmail: this.fieldEmail || "",
            localMailAlign: this.mailAlign || "top",
            emailValue: "",
            editingFieldLabel: false,
            updateTimer: null,
        };
    },
    computed: {
        displayFieldEmail() {
            return this.localFieldEmail || "E-posta";
        },
    },
    methods: {
        ...mapActions("forms", ["updateFormField"]),
        focusFieldLabel() {
            this.editingFieldLabel = true;
            this.$nextTick(() => {
                if (this.$refs.fieldLabelInput) {
                    this.$refs.fieldLabelInput.focus();
                }
            });
        },
        stopEditingFieldLabel() {
            this.editingFieldLabel = false;
            this.updateField();
        },
        onFocus(event) {
            event.target.parentElement.classList.add('focused');
        },
        onBlur(event) {
            event.target.parentElement.classList.remove('focused');
        },
        updateField() {
            let self = this;
            if (this.updateTimer) {
                clearTimeout(this.updateTimer);
            }
            this.updateTimer = setTimeout(function () {
            const updateFields = {
                email: {
                        fieldEmail: self.localFieldEmail,
                        mailAlign: self.localMailAlign,
                        altLabel: self.altLabel,
                        isRequired: self.isRequired,
                    },
                };
                self.updateFormField({
                    siteId: self.item.siteId,
                    formFieldId: self.item._id,
                updateFields: updateFields,
            });
                self.$emit("update-field", updateFields);
            }, 200);
        },
    },
    watch: {
        fieldEmail(newVal) {
            this.localFieldEmail = newVal;
        },
        mailAlign(newVal) {
            this.localMailAlign = newVal;
        },
        'item.email.fieldEmail': function (v) { this.localFieldEmail = v; },
        'item.email.altLabel': function (v) {
            // Alt label değişikliklerini takip et
        },
    },
};
</script>

<style lang="scss" scoped>
/* Base Email Styles */
.email {
    width: 100%;
    max-width: 700px;
    margin: clamp(0.5rem, 1.5vw, 1rem) auto;
    padding: clamp(0.625rem, 1.5vw, 0.875rem);
    position: relative;
    font-family: 'Inter', -apple-system, BlinkMacSystemFont, 'Segoe UI', Roboto, sans-serif;

    background: linear-gradient(145deg,
        rgba(255, 255, 255, 0.02) 0%,
        rgba(255, 255, 255, 0.01) 100%);
    border-radius: 0.75rem;
    border: 1px solid rgba(255, 255, 255, 0.06);
    transition: all 0.3s cubic-bezier(0.4, 0, 0.2, 1);

    &:hover {
        background: linear-gradient(145deg,
            rgba(255, 255, 255, 0.03) 0%,
            rgba(255, 255, 255, 0.02) 100%);
    }

    .field-label {
        display: block;
        font-size: clamp(0.95rem, 2.2vw, 1.1rem);
        font-weight: 600;
        margin-bottom: clamp(0.5rem, 1.2vw, 0.75rem);
        color: var(--text-primary, rgba(55, 65, 81, 0.9));
        line-height: 1.4;
        letter-spacing: -0.01em;
        cursor: pointer;

        .required-indicator {
            color: #ef4444;
            margin-left: 0.125rem;
            font-weight: 700;
        }
    }

    .field-label-input {
        font-size: clamp(0.95rem, 2.2vw, 1.1rem);
        font-weight: 600;
        margin-bottom: clamp(0.5rem, 1.2vw, 0.75rem);
        color: var(--text-primary, rgba(55, 65, 81, 0.9));
        line-height: 1.4;
        letter-spacing: -0.01em;
        border: none;
        background: transparent;
        outline: none;
        border-bottom: 2px solid #f26a52;
        padding: 0 0 2px 0;

        &::placeholder {
            color: rgba(156, 163, 175, 0.7);
        }
    }

    .input-wrapper {
        position: relative;
        transition: all 0.3s cubic-bezier(0.4, 0, 0.2, 1);
        min-width: 0;

        input {
            width: 100%;
            padding: clamp(0.6rem, 1.5vw, 0.75rem) clamp(0.6rem, 1.2vw, 0.75rem);
            font-size: clamp(0.875rem, 1.8vw, 0.9rem);
            line-height: 1.4;
            color: var(--text-primary, rgba(55, 65, 81, 0.9));
            background: rgba(255, 255, 255, 0.8);
            border: 1px solid rgba(209, 213, 219, 0.6);
            border-radius: 0.375rem;
            box-sizing: border-box;
            transition: all 0.3s cubic-bezier(0.4, 0, 0.2, 1);
            font-family: inherit;
            backdrop-filter: blur(10px);

            &::placeholder {
                color: transparent;
            }

            &:focus {
                outline: none;
                border-color: #f26a52;
                background: rgba(255, 255, 255, 0.95);
                box-shadow:
                    0 0 0 3px rgba(242, 106, 82, 0.1),
                    0 4px 12px rgba(0, 0, 0, 0.05);
                transform: translateY(-1px);
            }

            &:hover:not(:focus) {
                border-color: rgba(107, 114, 128, 0.4);
                background: rgba(255, 255, 255, 0.85);
            }
        }

        .floating-label {
            position: absolute;
            left: clamp(0.6rem, 1.2vw, 0.75rem);
            top: 50%;
            transform: translateY(-50%);
            font-size: clamp(0.875rem, 1.8vw, 0.9rem);
            color: rgba(107, 114, 128, 0.7);
            pointer-events: none;
            transition: all 0.3s cubic-bezier(0.4, 0, 0.2, 1);
            background: transparent;
            padding: 0 0.25rem;
            font-weight: 500;
        }

        .input-border {
            position: absolute;
            bottom: 0;
            left: 0;
            right: 0;
            height: 2px;
            background: linear-gradient(90deg, #f26a52, #e55a42);
            border-radius: 1px;
            transform: scaleX(0);
            transition: transform 0.3s cubic-bezier(0.4, 0, 0.2, 1);
        }

        &.focused .floating-label,
        &.filled .floating-label,
        input:focus ~ .floating-label,
        input.has-value ~ .floating-label {
            top: 0;
            transform: translateY(-50%);
            font-size: clamp(0.7rem, 1.6vw, 0.8rem);
            color: #f26a52;
            font-weight: 600;
            background: rgba(255, 255, 255, 0.9);
        }

        &.focused .input-border,
        input:focus ~ .input-border {
            transform: scaleX(1);
        }
    }
}

/* Left Alignment - Label solda, input sağda */
.email-align-left {
    display: flex;
    align-items: flex-start;
    gap: clamp(0.75rem, 2vw, 1rem);
    text-align: left;

    .field-label {
        min-width: clamp(100px, 20vw, 140px);
        flex-shrink: 0;
        margin-bottom: 0;
        padding-top: clamp(0.6rem, 1.5vw, 0.75rem);
        text-align: left;
    }

    .field-label-input {
        min-width: clamp(100px, 20vw, 140px);
        flex-shrink: 0;
        margin-bottom: 0;
        padding-top: clamp(0.6rem, 1.5vw, 0.75rem);
        text-align: left;
    }

    .input-wrapper {
        flex: 1;
    }

    @media (max-width: 768px) {
        flex-direction: column;
        gap: 0;

        .field-label, .field-label-input {
            min-width: auto;
            padding-top: 0;
            margin-bottom: clamp(0.5rem, 1.2vw, 0.75rem);
        }

        .input-wrapper {
            width: 100%;
        }
    }
        }

/* Right Alignment - Label solda sağa yaslanmış, input sağda */
.email-align-right {
            display: flex;
    align-items: flex-start;
    gap: clamp(0.75rem, 2vw, 1rem);

    .field-label {
        min-width: clamp(100px, 20vw, 140px);
        flex-shrink: 0;
        margin-bottom: 0;
        padding-top: clamp(0.6rem, 1.5vw, 0.75rem);
        text-align: right;
    }

    .field-label-input {
        min-width: clamp(100px, 20vw, 140px);
        flex-shrink: 0;
        margin-bottom: 0;
        padding-top: clamp(0.6rem, 1.5vw, 0.75rem);
        text-align: right;
    }

    .input-wrapper {
        flex: 1;
    }

    @media (max-width: 768px) {
            flex-direction: column;
        gap: 0;

        .field-label, .field-label-input {
            min-width: auto;
            padding-top: 0;
            margin-bottom: clamp(0.5rem, 1.2vw, 0.75rem);
            text-align: left;
        }

        .input-wrapper {
            width: 100%;
        }
    }
}

/* Center/Top Alignment (Default) */
.email-align-top {
    text-align: left;
    flex-direction: column;
}

// Mobil optimizasyonları
@media (max-width: 768px) {
    .email {
        margin: clamp(0.25rem, 1vw, 0.5rem) auto;
        padding: clamp(0.5rem, 1.2vw, 0.75rem);

        .field-label {
            font-size: clamp(0.9rem, 2vw, 1rem);
            margin-bottom: clamp(0.375rem, 1vw, 0.5rem);
        }

        .input-wrapper {
            input {
                padding: clamp(0.75rem, 2vw, 0.875rem) clamp(0.625rem, 1.5vw, 0.75rem);
                font-size: clamp(0.875rem, 2vw, 0.9rem);
                border-radius: 0.5rem;
            }

            .floating-label {
                left: clamp(0.625rem, 1.5vw, 0.75rem);
                font-size: clamp(0.875rem, 2vw, 0.9rem);

                &.focused,
                &.filled {
                    font-size: clamp(0.75rem, 1.8vw, 0.8rem);
                }
            }
        }
    }
}

@media (max-width: 480px) {
    .email {
        margin: 0.25rem auto;
        padding: 0.5rem;

        .input-wrapper {
            input {
                padding: 0.75rem 0.625rem;
                font-size: 0.875rem;
            }

            .floating-label {
                left: 0.625rem;
                font-size: 0.875rem;

                &.focused,
                &.filled {
                    font-size: 0.75rem;
                }
            }
        }
    }
}

/* Reduced Motion Support */
@media (prefers-reduced-motion: reduce) {
    .email,
    .input-wrapper,
    .input-wrapper input,
    .floating-label,
    .input-border {
        transition: none;
    }

    .input-wrapper input:focus {
        transform: none;
    }
}

/* High Performance Mode */
.input-wrapper {
    will-change: transform;

    input {
        will-change: transform, box-shadow;
    }

    .floating-label {
        will-change: transform, color, font-size;
    }

    .input-border {
        will-change: transform;
    }
}
</style>
